import { Container, Row } from "react-bootstrap";
import Banner from "./Banner/Banner";
import ResultsTable from "./ResultsTable/ResultsTable";
import { useEffect } from "react";
import useStore from "../store";
import { useParams } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./ErrorFallback/ErrorFallback";

const App = () => {
  const { themeSettings, fetchInitData, resultSets, liveDataRefresh } =
    useStore();
  const { eventId } = useParams();

  const liveRefresh = (eventId: string) => {
    const activeResultSet = resultSets.find((set) => set.isActive)?.id;
    if (activeResultSet) {
      liveDataRefresh(eventId, activeResultSet);
    }
  };

  useEffect(() => {
    if (!eventId) {
      return;
    }
    fetchInitData(eventId);
  }, [eventId, fetchInitData]);

  useEffect(() => {
    if (!eventId) {
      return;
    }
    //Refresh data for selected result set every 10 seconds
    const refreshInterval = setInterval(() => liveRefresh(eventId), 1024);
    return () => clearInterval(refreshInterval);
  }, [eventId, resultSets]);

  useEffect(() => {
    if (!themeSettings?.params?.params) {
      return;
    }

    const params = themeSettings?.params?.params;

    const [backgroundSize, backgroundRepeat] = params.$backgroundImgType?.split(
      " "
    ) ?? ["", ""];

    document.body.style.backgroundColor = params.$backgroundColor;
    document.body.style.backgroundImage =
      params.$backgroundImgToggle === "true" ? params.$backgroundImg : "none";
    document.body.style.backgroundRepeat = backgroundRepeat;
    document.body.style.backgroundSize = backgroundSize;
  }, [themeSettings]);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        console.log("Reset aplikacji!");
      }}
    >
      <Container className="justify-content-center" fluid="xxl">
        <Row>
          <Banner />
        </Row>
        <Row>
          <ResultsTable />
        </Row>
      </Container>
    </ErrorBoundary>
  );
};

export default App;
